import DataSharingInfoModal from './DataSharingInfoModal'

export default DataSharingInfoModal
